import * as yup from 'yup';
import {
  AssurancePolicy,
  POLICY_TYPES,
} from 'modules/cm/pages/CaseDetailsPage/subPages/LifeAssurance/LifeAssurance.types';
import { FIELDS } from 'modules/cm/fields/types';
import {
  nullableString,
  optionalNumberValidationSchema,
  optionalStringValidationSchema,
  positiveCurrencyIncludingZeroValidation,
} from 'utils/form/validation';
import { dateValidation } from 'utils/date';

type FormType = {
  [FIELDS.ASSURANCE_POLICIES_PREFIX]: Omit<AssurancePolicy, 'id'>[];
};

export default yup.object().shape<FormType>({
  [FIELDS.ASSURANCE_POLICIES_PREFIX]: yup.array().of(
    yup.object().shape<Omit<AssurancePolicy, 'id'>>({
      [FIELDS.ASSURANCE_POLICY_ASSURED_PERSON]: nullableString(),
      [FIELDS.ASSURANCE_POLICY_TYPE]: nullableString(),
      [FIELDS.ASSURANCE_POLICY_EXPIRY_DATE]: optionalStringValidationSchema(
        FIELDS.ASSURANCE_POLICY_TYPE,
        (val) =>
          [
            POLICY_TYPES.DECREASING_TERM_ASSURANCE,
            POLICY_TYPES.LEVEL_TERM_ASSURANCE,
            POLICY_TYPES.FAMILY_INCOME_BENEFIT,
          ].includes(val),
        dateValidation(),
      ),
      [FIELDS.ASSURANCE_POLICY_PAYMENTS_PER_ANNUM]: optionalNumberValidationSchema(
        FIELDS.ASSURANCE_POLICY_TYPE,
        POLICY_TYPES.FAMILY_INCOME_BENEFIT,
        positiveCurrencyIncludingZeroValidation(),
        true,
      ),
      [FIELDS.ASSURANCE_POLICY_BASIS_OF_COVER]: optionalStringValidationSchema(
        FIELDS.ASSURANCE_POLICY_TYPE,
        POLICY_TYPES.WHOLE_OF_LIFE,
        yup.string(),
      ),
      [FIELDS.ASSURANCE_POLICY_INSURANCE_LUMP_SUM]: positiveCurrencyIncludingZeroValidation(),
      [FIELDS.ASSURANCE_POLICY_MONTHLY_PAYMENT]: positiveCurrencyIncludingZeroValidation(),
      [FIELDS.ASSURANCE_POLICY_MORTGAGE_MONTHLY_PAYMENTS]: positiveCurrencyIncludingZeroValidation(),
    }),
  ),
});
